export default __webpack_public_path__ + "static/hp-brand-deck-26-4ef0991a0c96806370857350244bc941.png";